// @utils/useIoState.ts
import { useState, useCallback } from 'react';

import type { IOts } from "@ps-bridge/interop";
import type { StateHandle, StateRead, StateUpdate } from "@ps-bridge/capabilitiesTypes";
import { ioEffect } from '@utils/effects/branded';

import { ok } from "@ps-bridge/ok";
import type { Ok } from "@ps-bridge/ok";

export function useIoState<S>(initialState: S): StateHandle<S> {
    const [state, setState] = useState<S>(initialState);

    // Memoize the IO-based setter to avoid unnecessary re-renders
    const setIoState = useCallback(
        (newState: S): IOts<Ok> =>
            ioEffect(() => {
                setState(newState);
                return ok;
            }),
        [setState],
    );

    const read = state as StateRead<S>;
    const set = setIoState as StateUpdate<S>;

    return { read, set };
}
